import {NextPage} from "next";
import {StoreFeedView} from "../components/storeFeed/StoreFeedView";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {wrapper} from "../app/store";
import Head from "next/head";
import React from "react";
import {useAppSelector} from "../app/hooks";
import {selectPrimaryLocation} from "../redux/user/userSlice";

const StoreFeed: NextPage = () => {
  const location = useAppSelector(selectPrimaryLocation)

  const metaTitle = location ? `FitGenie | Healthy Meal Delivery Near ${location.address?.getFullStreetAddress()}` : 'FitGenie | Healthy Meal Delivery Near You'
  return <>
    <Head>
      <title>{metaTitle}</title>
      <meta property="og:title" key="og:title" content={metaTitle} />
      <meta property="og:url" key="og:url" content={`${process.env.NEXT_PUBLIC_APP_DOMAIN_URL}/store-feed`}/>
      <meta property="twitter:title" key="twitter:title" content={metaTitle}/>
    </Head>
    <StoreFeedView />
  </>
}

export const getStaticProps = wrapper.getStaticProps(store => async ({ locale }: any) => {
  const metaTitle = 'FitGenie | Healthy Meal Delivery Near You'
  const metaUrl = `${process.env.NEXT_PUBLIC_APP_DOMAIN_URL}/store-feed`

  return {
    props: {
      metaTags: [
        {
          property: 'og:title',
          content: metaTitle
        },
        {
          property: 'twitter:title',
          content: metaTitle
        },
        {
          property: 'og:url',
          content: metaUrl
        }
      ],
      ...await serverSideTranslations(locale, ['common', 'landing', 'auth', 'location', 'store', 'payment', 'checkout', 'order']),
    }
  }
});

export default StoreFeed